// Carrier-specific constants shared across provider modules. Domain
// facts about airlines that affect seat-selection / fare rules — kept
// out of any single provider so multi-provider consumers (kyte +
// amadeus today) read from one source.

// Ryanair Holdings carriers: FR Ryanair, RR Buzz, RK Lauda. Used to
// gate "seat selection mandatory" behaviour — all three share the
// included-but-must-be-picked seat policy.
export const RYANAIR_CARRIER_CODES = ['FR', 'RR', 'RK']
